import React, { useEffect, useState } from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import pencilIcon from './../../../../assets/icons/editPencil.png'
import filterIcon from './../../../../assets/icons/filter 1.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import VATEditDialog from '../VATEditDialog/VATEditDialog.tsx';
import { Button, Grid } from '@mui/material'
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import { toast } from 'react-toastify';
import VATSetupDialog from '../VATSetupDialog/VATSetupDialog.tsx';


function VATSetupPage(props) {
    const columns = [
        {
            field: 'name', headerName: 'Name', align: 'center',
            renderCell: (params) =>
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px", cursor: "pointer" }} onClick={() => { selectDataForEdit(params.value); setOpen(true) }} >
                    <span style={{ color: "blue", cursor: "pointer" }}>{params.value} </span>
                    <img src={pencilIcon} alt="" style={{ width: ".8rem" }} />
                </div>,
            headerAlign: 'center', flex: 1
        },

        { field: 'percentage', headerName: 'Amount(%)', align: 'center', headerAlign: 'center', flex: 1 },
    ];

    const [dataRows, setDataRows] = useState([])
    const [open, setOpen] = React.useState(false)
    const [selectedDatas, setselectedDatas] = useState()

    const selectDataForEdit = (props) => {
        console.log(props);
        console.log(dataRows);
        var obj = dataRows.find(x => x.name == props);
        console.log(obj)
        setselectedDatas(obj.id)
    }

    const handleAddItem = (AddSectionData) => {
        setOpenAddSection(AddSectionData)
        loadData();
        console.log(AddSectionData)
    }
    const handleUpdateItem = (AddItemData) => {
        setOpen(AddItemData);
        loadData();
    }

    const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const [openAddSection, setOpenAddSection] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [selectedData, setSelectedData] = useState({})

    const handleClickOpen = () => {
        setOpenAddSection(true);
        setDialogType('Add Vat');
    }

    const handleAddMenuDialogData = (data) => {
        setSelectedData(data);
        loadData();
    }

    // const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     if (props.isItem != 6) {
    //       setOpen(true)
    //     }
    //     else {
    //       setAnchorEl(event.currentTarget);
    //     }
    //   }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openDropdown = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getselectedData = (props) => {
        console.log(props)
        setSelectedDatarows(props)
    }

    const deleteBin = () => {

        var url = apiAddress + "/api/Vat/Delete"
        axios
            .put(url, selectedDataRows)
            .then((response) => {
                toast.success("successfully deleted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

                setopenConfirmaitonModal(false)
                loadData();
            })

        //loadData()

    }
    const errorToast = (msg) => {
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const restaurant = JSON.parse(localStorage.getItem('restaurant'));

    const apiAddress = process.env.REACT_APP_SECRET;
    useEffect(() => {
        loadData();
    }, [])

    const loadData = () => {
        axios({
            method: 'get',
            url: apiAddress + '/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=' + restaurant.id,
        })
            .then((response) => {
                console.log(response)
                var list = [];
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.id,
                        name: dt.name,
                        percentage: dt.percentage,
                        restaurantId: dt.restaurantId
                    }
                    list.push(obj);
                })
                setDataRows(list);
            })
            .catch((error) => {

            });
    }


    return (
        <div>
            <div>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    mt={2}
                    mb={2}
                >
                    <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to delete this?"} open={openConfirmaitonModal} onyes={deleteBin} close={() => { setopenConfirmaitonModal(false) }} />
                    <Grid item>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <Button
                                    color="primary"
                                    size="medium"
                                    variant="contained"
                                    style={{ borderRadius: '50%', minWidth: 'auto' }}
                                    onClick={handleClickOpen}
                                >
                                    +
                                </Button>
                            </Grid>
                            <Grid item>
                                <div className='roundedCorner'>
                                    <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => { selectedDataRows.length == 0 ? errorToast("Please select a row") : setopenConfirmaitonModal(true) }} />
                                </div>
                            </Grid>
                            <Grid item>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
                {/* <FilterComponents title={"OK"} isItem={2} /> */}
                <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData} />
                <VATSetupDialog open={openAddSection}
                    dialogType={dialogType} onHandleAddItem={handleAddItem} onHandleSelectedData={handleAddMenuDialogData} />
            </div>
            {
                open ? (
                    <VATEditDialog open={open}
                        onHandleAddItem={handleUpdateItem}
                        title={props.title} isEdit={"true"} selectedId={selectedDatas} />
                ) : ""
            }
        </div>
    );
}

export default VATSetupPage;